import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthServerBase } from '../utils/runtime';

const AUTH_SERVER = getAuthServerBase();

function AjouterSpecialite() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [specialities, setSpecialities] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');

  useEffect(() => {
    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(data => setUser(data.user || data))
      .catch(() => {
        alert("Session expirée");
        window.location.href = '/';
      });
  }, []);

  useEffect(() => {
    if (!user?.email) return;

    fetch('https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/specialities')
      .then(res => res.json())
      .then(setSpecialities)
      .catch(err => console.error('Erreur chargement spécialités:', err));
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedSpeciality) return;

    try {
      const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${user.email}`);
      const userData = await userRes.json();

      const response = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${userData.user_id}/specialities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          speciality_id: selectedSpeciality,
          license_number: licenseNumber
        })
      });

      if (response.ok) {
        alert('Spécialité ajoutée avec succès');
        navigate('/professional/dashboard');
      } else {
        const errorText = await response.text();
        console.error('Erreur ajout spécialité:', errorText);
        alert('Échec de l’ajout');
      }
    } catch (err) {
      console.error('Erreur totale:', err);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Ajouter une spécialité</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="speciality">Choisir une spécialité :</label>
        <select
          id="speciality"
          value={selectedSpeciality}
          onChange={(e) => setSelectedSpeciality(e.target.value)}
          required
        >
          <option value="">-- Sélectionner --</option>
          {specialities.map(spec => (
            <option key={spec.speciality_id} value={spec.speciality_id}>
              {spec.name}
            </option>
          ))}
        </select>

        <br /><br />

        <label htmlFor="license">Numéro de licence :</label>
        <input
          type="text"
          id="license"
          value={licenseNumber}
          onChange={(e) => setLicenseNumber(e.target.value)}
          placeholder="ex. 123456-AB"
          required
        />

        <br /><br />

        <button type="submit" style={{ backgroundColor: '#6a1b9a', color: '#fff', padding: '8px 16px', border: 'none', borderRadius: '4px' }}>
          Ajouter
        </button>
      </form>
    </div>
  );
}

export default AjouterSpecialite;
